export default __webpack_public_path__ + "static/media/coviupdate.0d82b275.png";